import dayjs, { Dayjs } from 'dayjs'
import { RuleAction } from './ruleAction'
import { AdjustmentType, PackageType } from '$constants'
import {
  ClockinRuleOverride,
  transformClockinRuleOverrideOnGet,
  transformClockinRuleOverrideOnSave,
} from './clockinRuleOverride'
export interface ClockinRuleDetail {
  id: string
  clockinId: string
  ruleId: string
  ruleName: string
  override: ClockinRuleOverride | null
  ruleRate: number
  ruleType: AdjustmentType
  startTime: Dayjs
  endTime: Dayjs
  source: PackageType
  totalHours: number
  roundUpHours: boolean
  totalPaidHours: number
  errorMessage?: string

  // after mercuryapi has processed the rule these are the final values that are returned
  // we can use these values instead of calculating in the frontend if the rule has already been processed.
  // new added clocks/overrides etc will not have these fields
  processedTotalHours?: number
  processedRuleCost?: number

  // additional properties
  length?: number
  actions: RuleAction[]
  packageId: string
}

// Functions to apply transformations to ClockinRuleDetail object
export const transformClockinRuleDetailOnGet = (
  clockinRuleDetail: ClockinRuleDetail
): ClockinRuleDetail => {
  return {
    ...clockinRuleDetail,
    startTime: dayjs(clockinRuleDetail.startTime),
    endTime: dayjs(clockinRuleDetail.endTime),
    override: clockinRuleDetail.override
      ? transformClockinRuleOverrideOnGet(clockinRuleDetail.override)
      : null,
  }
}

export const transformClockinRuleDetailOnSave = (
  clockinRuleDetail: ClockinRuleDetail
): ClockinRuleDetail => {
  return {
    ...clockinRuleDetail,
    startTime: clockinRuleDetail.startTime.utc(),
    endTime: clockinRuleDetail.endTime.utc(),
    override: clockinRuleDetail.override
      ? transformClockinRuleOverrideOnSave(clockinRuleDetail.override)
      : null,
  }
}
